import React from 'react';

const UserTypeToggle = ({ userType, onUserTypeChange }) => {
  return (
    <div className="flex justify-center mb-12">
      <div className="bg-white rounded-full p-1 shadow-card">
        <button 
          className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
            userType === 'screen-owner' 
              ? 'bg-primary text-white' 
              : 'text-text-secondary hover:text-primary'
          }`}
          onClick={() => onUserTypeChange('screen-owner')}
        >
          Screen Owner
        </button>
        <button 
          className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
            userType === 'advertiser' 
              ? 'bg-primary text-white' 
              : 'text-text-secondary hover:text-primary'
          }`}
          onClick={() => onUserTypeChange('advertiser')}
        >
          Advertiser
        </button>
      </div>
    </div>
  );
};

export default UserTypeToggle;